module.exports = __webpack_public_path__ + "static/media/signup1.8f760b39.jpg";